import { IApplicationState } from '../../types/redux';

export function selectSearchQuery(state: IApplicationState) {
  return state.searchQuery;
}
